var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Snackbar'),_c('Hero',{attrs:{"title":"Relatórios de vídeo","message":"Gestão dos relatórios de vídeo entregues pelos jogadores.","icon":"mdi-video-outline","action":"withAction","layout_type":"video"}}),_c('TableVideoReports')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }